(ns app.front.view.registration.core
  (:require [app.front.view.not-found :as not-found]
            [app.front.view.profile.licences :as profile-licences]
            [app.front.view.registration.authority-user-details :as authority-user-details]
            [app.front.view.registration.user-details :as user-details]
            [core.front.event :refer [<sub >evt]]
            [re-chain.core :as rc]
            [re-frame.core-instrumented :as rf]
            [schema.core :as s]))


(rc/reg-chain
  ::decode-email-confirmation-token
  (fn [_ [_ token]]
    {:comm/command {:command         :user/decode-email-confirmation-token
                    :data            {:user/token token}
                    :on-bad-request  [::decode-email-confirmation-token-failure]
                    :on-unauthorized [::decode-email-confirmation-token-failure]}})
  (fn [{:keys [db]} [_ token _ user-data]]
    {:db (-> db
             (assoc :session/user nil)
             (assoc ::user-data (merge user-data
                                       {:user/token token})))}))


(rc/reg-chain
  ::decode-email-confirmation-token-failure
  (fn [_ [_ status body]]
    (js/console.error "::decode-email-confirmation-token-failure" status body)))


(rf/reg-sub
  ::user-data
  (fn [db [_ path]]
    (let [doc (::user-data db)]
      (if path (get-in doc path) doc))))


(defn user-details-subview []
  (cond
    (nil? (<sub [::user-data [:user/email]])) [not-found/not-found-view]
    (some? (<sub [::user-data [:user/groups]])) [authority-user-details/view (<sub [::user-data])]
    :else [user-details/view (<sub [::user-data])]))



(def user-details-view
  {:name        :registration-user-details
   :view        user-details-subview
   :public?     true
   :parameters  {:path {:token s/Str}}
   :controllers [{:parameters {:path [:token]}
                  :start      (fn [{param :path}]
                                (when (some? (:token param))
                                  (>evt [::decode-email-confirmation-token (:token param)]))
                                (>evt [::profile-licences/set-user-licences []]))}]})
